import React, { useContext, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import StarRatings from 'react-star-ratings';
import { motion } from 'framer-motion';

import TagManager from 'react-gtm-module';

import { store } from '../../store/app/Store';

import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import Box from '@mui/material/Box';

import getstarted from '../../imgs/get-started-2.png';
import getstartedpartner from '../../imgs/get-started-partner-v3.png';
import google from '../../imgs/google-2025.png';
// import lenders from '../../imgs/lender-group.png';
import greeting from '../../imgs/greetings.png';

import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';

import Loading from 'components/Loading2';
import config from '../../config';

import classes from 'styles/Landing.module.scss';

const sayHi = {
  initial: { opacity: 0, x: -100 },
  animate: { opacity: 1, x: 0 },
  transition: { duration: 0.6 },
};

const fadeLeft = {
  initial: { opacity: 0, x: 100 },
  animate: { opacity: 1, x: 0 },
  transition: { duration: 0.6, delay: 0.7 },
};

const fadeRight = {
  initial: { opacity: 0, x: -100 },
  animate: { opacity: 1, x: 0 },
  transition: { duration: 0.6, delay: 0.5 },
};

const fadeZoomIn = {
  initial: { opacity: 0, scale: 0.65 },
  animate: { opacity: 1, scale: 1 },
  transition: { duration: 0.6, delay: 0.9 },
};

const Landing = (props) => {
  const { t, setActiveStep, options, setfromLanding, isEmbed, appLoading, isPartner } = props;
  const globalState = useContext(store);
  const { dispatch } = globalState;

  const vals = {
    a: 'pre_approve',
    b: 'purchase',
    c: 'switch',
  };

  const FinanceA = withRouter(({ history }) => (
    <Button
      onClick={() => {
        dispatch({ type: 'financeType', newVal: 'a' });
        dispatch({ type: 'inProgress', newVal: true });

        TagManager.dataLayer({
          dataLayer: {
            loanType: vals['a'],
          },
        });

        const route = props.match.url;
        const updatedRoute = route.replace('options', 'step-2');
        props.history.push(updatedRoute + props?.history?.location?.search);
        setActiveStep(2);
        setfromLanding(true);
      }}
      variant={'contained'}
      color="primary"
      className={classes.btnOption}
      id="options-finance-a">
      {t('questions:financeType.option.1.bold')}
    </Button>
  ));

  const FinanceB = withRouter(({ history }) => (
    <Button
      onClick={() => {
        dispatch({ type: 'financeType', newVal: 'b' });
        dispatch({ type: 'inProgress', newVal: true });

        TagManager.dataLayer({
          dataLayer: {
            loanType: vals['b'],
          },
        });

        const route = props.match.url;
        const updatedRoute = route.replace('options', 'step-2');
        props.history.push(updatedRoute + props?.history?.location?.search);
        setActiveStep(2);
        setfromLanding(true);
      }}
      variant={'contained'}
      color="primary"
      className={classes.btnOption}
      id="options-finance-b">
      {t('questions:financeType.option.2.bold')}
    </Button>
  ));

  const FinanceC = withRouter(({ history }) => (
    <Button
      onClick={() => {
        dispatch({ type: 'financeType', newVal: 'c' });
        dispatch({ type: 'inProgress', newVal: true });

        TagManager.dataLayer({
          dataLayer: {
            loanType: vals['c'],
          },
        });

        const route = props.match.url;
        const updatedRoute = route.replace('options', 'step-2');
        props.history.push(updatedRoute + props?.history?.location?.search);
        setActiveStep(2);
        setfromLanding(true);
      }}
      variant={'contained'}
      color="primary"
      className={classes.btnOption}
      id="options-finance-c">
      {t('questions:financeType.option.3.bold')}
    </Button>
  ));

  const pointForm = [1, 2, 3];

  // GTM dataLayer push for timer trigger
  useEffect(() => {
    const tagManagerArgs = {
      dataLayer: {
        event: 'Intro',
      },
    };
    TagManager.dataLayer(tagManagerArgs);
  }, []);

  return (
    <section className={isEmbed ? classes.embed : classes.hero}>
      <Container maxWidth="md">
        <Grid container justifyContent="center">
          <Grid item xs={12} md={12}>
            <Box sx={{ display: { xs: 'none', sm: 'none', md: 'block' } }}>
                <motion.div {...sayHi}>
                  <img src={greeting} width="100" height="79" alt="Hi!" loading="lazy" />
                </motion.div>
            </Box>
            <Box sx={{ display: { xs: 'block', sm: 'block', md: 'none' } }}>
                <motion.div {...sayHi}>
                  <img src={greeting} width="70" height="55.44" alt="Hi!" loading="lazy" />
                </motion.div>
            </Box>
            <motion.div {...fadeRight}>
              <h1
                className="topTitle"
                dangerouslySetInnerHTML={{
                  __html: t('title', {
                    start: "<span class='highlight'>",
                    end: '</span>',
                    interpolation: { escapeValue: false },
                  }),
                }}
              />
              <p style={{ lineHeight: `1.6rem`, maxWidth: `83%`, marginBottom: `2rem` }}>
                {t('sub')}
              </p>

              {/* <Box
                sx={{
                  display: { xs: 'block', sm: 'block', md: 'none' },
                  maxWidth: { xs: `100%`, sm: `50%`, md: `100%` },
                }}>
                <img
                  src={lenders}
                  alt="Lenders"
                  width="100%"
                  style={{ filter: 'grayscale(100%)' }}
                />
              </Box> */}
            </motion.div>
          </Grid>
        </Grid>
        {!options ? (
          <Grid container>
            <Grid item xs={12} md={6}>
              <motion.div {...fadeZoomIn}>
                <List component="ul">
                  {pointForm.map((item) => (
                    <ListItem
                      key={item}
                      alignItems="flex-start"
                      disableGutters
                      style={{ paddinTop: `0px` }}>
                      <ListItemIcon
                        style={{
                          marginTop: '.2rem',
                          minWidth: `auto`,
                          flexShrink: `unset`,
                          paddingRight: `.5rem`,
                        }}>
                        <CheckCircleOutlineIcon color="secondary" style={{ fontSize: '1.25rem' }} />
                      </ListItemIcon>
                      <p className={classes.points}>
                        <strong>{t('steps.' + item + '.bold')}</strong>{' '}
                        {t('steps.' + item + '.copy')}
                      </p>
                    </ListItem>
                  ))}
                </List>
              </motion.div>
              <motion.div {...fadeZoomIn}>
                <>
                  {appLoading ? (
                    <Loading />
                  ) : // Opens app in a new window if the instance is in a incognito browser window.
                  props?.isIncognito ? (
                    <Button
                      variant="contained"
                      color="primary"
                      className={classes.btnOption}
                      style={{ background: `#147AC8` }}
                      id="btnGetStarted"
                      href={`${config.hoa}${props.location.pathname
                        .toString()
                        .replace(/(?:\/+(\?))/, '$1')
                        .replace(/\/+$/, '')}/step-1${props?.history?.location?.search}`}
                      target="_blank"
                      disabled={appLoading}>
                      {t('items.0.title1')}
                    </Button>
                  ) : (
                    <Button
                      variant="contained"
                      color="primary"
                      className={classes.btnOption}
                      style={{ background: `#147AC8` }}
                      id="btnGetStarted"
                      onClick={() => {
                        const route = props.match.url;
                        const updatedRoute = route === '/' ? route + `step-1` : route + `/step-1`;
                        props.history.push(updatedRoute + props?.history?.location?.search);
                        setActiveStep(1);
                        setfromLanding(true);
                      }}
                      disabled={appLoading}>
                      {t('items.0.title1')}
                    </Button>
                  )}
                  {!isEmbed && !isPartner && (
                    <Box
                      sx={{
                        display: 'flex',
                        justifyContent: { xs: 'center', md: 'flex-start' },
                        alignItems: 'center',
                        marginTop: '1rem',
                      }}>
                      <img
                        src={google}
                        alt="Google"
                        height={40}
                        style={{ display: `block`, margin: `0` }}
                      />
                      <div
                        style={{
                          display: 'flex',
                          flexDirection: 'column',
                        }}>
                        <small>
                          <a
                            href="https://www.google.com/search?hl=en-CA&gl=ca&q=Homewise,+383+Spadina+Rd+unit+b,+Toronto,+ON+M5P+2W1&ludocid=8718664546004722507&lsig=AB86z5Wt3pQFdmfwA4Do6octDOms&mat=CQZUY1VqAYZkElYBezTaAdAanbd3GAwnxUkuaLh1ZTM7aV8zTbqX46R_FiWTl0uAi2Gaczp_dN3G_wSri-Y_XzcgAP6jg5wpaeZiFWthBuN-B-2CAgZ9XWeV-OCora6eXA#lrd=0x882b33a2363b2179:0x78feeb360c67634b,1"
                            style={{ color: '#333333', marginLeft: 0, textDecoration: `none` }}
                            target="_blank"
                            rel="noopener noreferrer">
                            500+ Google Reviews
                          </a>
                        </small>
                        <div>
                          <StarRatings
                            rating={4.9}
                            starRatedColor="#e5722b"
                            starEmptyColor="#F5B58D"
                            numberOfStars={5}
                            starDimension="15px"
                            starSpacing="2px"
                            name="Google Reviews"
                          />
                          <small style={{ marginLeft: `.5rem` }}>4.9</small>
                        </div>
                      </div>
                    </Box>
                  )}
                </>
              </motion.div>
            </Grid>
            <Grid item xs={12} md={6} sx={{ display: { xs: 'none', sm: 'none', md: 'block' } }}>
              <motion.div {...fadeLeft}>
                <img
                  src={isPartner ? getstartedpartner : getstarted}
                  alt="Get Started with Homewise"
                  width="800"
                  className={classes.modelHome}
                  loading="lazy"
                />
              </motion.div>
            </Grid>
          </Grid>
        ) : (
          <Grid container justifyContent="center">
            <Grid item xs={12} md={6}>
              <List component="ul">
                {pointForm.map((item) => (
                  <ListItem
                    key={item}
                    alignItems="flex-start"
                    disableGutters
                    style={{ paddinTop: `0px` }}>
                    <ListItemIcon
                      style={{
                        marginTop: '.2rem',
                        minWidth: `auto`,
                        flexShrink: `unset`,
                        paddingRight: `.5rem`,
                      }}>
                      <CheckCircleOutlineIcon color="secondary" />
                    </ListItemIcon>
                    <p className={classes.points}>
                      <strong>{t('steps.' + item + '.bold')}</strong> {t('steps.' + item + '.copy')}
                    </p>
                  </ListItem>
                ))}
              </List>
            </Grid>
            <Grid item xs={12} md={6} sx={{ display: { xs: 'none', sm: 'none', md: 'block' } }}>
              <img
                src={isPartner ? getstartedpartner : getstarted}
                alt="Get Started with Homewise"
                width="400"
                className={classes.modelHome}
                loading="lazy"
              />
            </Grid>
            <Grid item xs={12}>
              {appLoading ? (
                <Loading />
              ) : (
                <div className={classes.buttonGrid}>
                  <FinanceA />
                  <FinanceB />
                  <FinanceC />
                </div>
              )}
            </Grid>
            <Grid item xs={12}>
              <p className="legal" style={{ marginTop: `1rem` }}>
                {t('legal')}
              </p>
            </Grid>
          </Grid>
        )}
      </Container>
    </section>
  );
};

export default withRouter(withTranslation('getstarted')(Landing));
